import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/ui/rating.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/user/[handle]/detail.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/user/[handle]/page.module.css");
